import { CenteredCard } from '../components/centered.card/centered.card';
import type { MithrilVNode } from '../mithril';
import { ForgotPasswordComponent } from '../modules/user/forgot.password';
import { ForgotPasswordCtrl } from '../modules/user/forgot.password.ctrl';
import { IkePage, type IkePageConfig, IkePageName } from './page';

export const ForgotPasswordPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.forgotPassword,
	path: '/forgot-password',
	auth: { required: false },
	layout: { nav: false, banner: false },
};

export class ForgotPasswordPage extends IkePage {
	private component: ForgotPasswordComponent;

	constructor() {
		super(ForgotPasswordPageConfig);

		const ctrl = new ForgotPasswordCtrl();
		this.component = new ForgotPasswordComponent(ctrl);
	}

	get nodes(): MithrilVNode {
		return CenteredCard.view(this.component.view());
	}
}
